// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2143":"app","4998":"chunk-vendors"}[chunkId] + "." + {"2143":"e5a19531","4998":"a317e429"}[chunkId] + ".css";
};